var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChildrenmarriage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34357 20.9994C12.3993 20.9994 15.6871 17.9464 15.6871 14.1804C15.6871 10.4143 12.3993 7.36133 8.34357 7.36133C4.28783 7.36133 1 10.4143 1 14.1804C1 17.9464 4.28783 20.9994 8.34357 20.9994Z",
    stroke: "#858991",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1793 17.3622C19.6912 17.3622 22.5382 14.7186 22.5382 11.4575C22.5382 8.19638 19.6912 5.55273 16.1793 5.55273C12.6673 5.55273 9.82031 8.19638 9.82031 11.4575C9.82031 14.7186 12.6673 17.3622 16.1793 17.3622Z",
    stroke: "#858991",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6616 5.54285H15.6872L12.7539 2.81904L13.7283 1H18.6206L19.6052 2.81904L16.6616 5.54285Z",
    stroke: "#858991",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildrenmarriage);
export default __webpack_public_path__ + "static/media/childrenmarriage.d938289b54ded032657444950a18c96d.svg";
export { ForwardRef as ReactComponent };